import CPG_SHEF_IDS from 'common/shef-profiles/CPGShefs';
import React from 'react';
import { MEAL_TYPE_SELECTOR } from 'src/pages/consumer/dish-first/explore/Constants';
import { getMealTypeId } from 'src/pages/consumer/dish-first/explore/utils';
import {
  ConsumerOrderDishSelectionItem,
  ConsumerOrderDishSelectionItemFormat,
} from '../ConsumerOrderDishSelectionItem';
import { ConsumerOrderDishSelectionRow } from '../ConsumerOrderDishSelectionRow';
import { useConsumerOrderDishSelection } from './hooks';
import { CollectionAnchor, Container } from './styles';
import { IConsumerOrderDishSelectionProps } from './types';

export const ConsumerOrderDishSelection: React.FC<IConsumerOrderDishSelectionProps> = (
  props: IConsumerOrderDishSelectionProps
) => {
  const {
    className,
    hasMultipleMealTypes,
    isShefMenu,
    isUnavailable,
    location,
    menuCounts,
    remainingQuantities,
    overlay,
    shef,
    showOverlay,
    sections,
    isShefAvailable,
    nextDeliveryDate,
    isShefAvailableInFuture,
    openModal,
    showModalPrompt,
    isEditingOrder,
    shefId,
    ...rest
  } = useConsumerOrderDishSelection(props);

  const shouldShowAnchors = props.attachAnchors && isShefMenu && hasMultipleMealTypes;

  return (
    <Container className={className}>
      {sections.map((section) => (
        <React.Fragment key={section.title}>
          {shouldShowAnchors && (
            <CollectionAnchor
              data-role={MEAL_TYPE_SELECTOR}
              data-meal-type={section.mealType}
              id={getMealTypeId(section.mealType)}
              key={getMealTypeId(section.mealType)}
            />
          )}
          {!CPG_SHEF_IDS.includes(shefId) && (
            <ConsumerOrderDishSelectionRow
              title={section.title}
              key={section.title}
              blur={showOverlay ?? false}
              suppressTitle={!!shef?.celebrityEventType}>
              {section.items.map((foodItem) => (
                <ConsumerOrderDishSelectionItem
                  format={ConsumerOrderDishSelectionItemFormat.ORDER}
                  key={foodItem.id}
                  foodItem={foodItem}
                  isUnavailable={isUnavailable}
                  remainingQuantity={remainingQuantities[foodItem.id]}
                  quantity={menuCounts[foodItem.id] ?? 0}
                  location={location}
                  shef={shef}
                  isShefAvailable={isShefAvailable}
                  nextDeliveryDate={nextDeliveryDate}
                  isShefAvailableInFuture={isShefAvailableInFuture}
                  openModal={openModal}
                  showModalPrompt={showModalPrompt}
                  isEditingOrder={isEditingOrder}
                  {...rest}
                />
              ))}
            </ConsumerOrderDishSelectionRow>
          )}
        </React.Fragment>
      ))}
      {showOverlay && overlay}
    </Container>
  );
};
